module.exports = __webpack_public_path__ + "img/banner1@2x.ee7e3e31.png";